import { ComponentProps } from 'react'

import {
  createMemoryRouter,
  RouterProvider,
  UNSAFE_LocationContext as LocationContext,
  UNSAFE_RouteContext as RouteContext,
  useNavigate,
} from 'react-router-dom'

import { LoadingIcon, Stack } from '@cash-design-system/react'
import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'

import { journeyRoutes } from './routes'
export const createJourneyRouter = (...[routes, opts]: Parameters<typeof createMemoryRouter>) => {
  return createMemoryRouter([...routes, ...journeyRoutes], opts)
}

type JourneyRouter = ReturnType<typeof createJourneyRouter>

const HIDE_LOADER_PATHS = ['/web/view/moneybot/chat', `/dl/flow/${FlowType.SEND_OON_POOL_CONTRIBUTION_PAYMENT}`]

export const JourneyPaneRouter = ({ router, initialRoute }: { router: JourneyRouter; initialRoute?: string }) => {
  router.navigate = useNavigate() as JourneyRouter['navigate']

  /**
   * This is a hack to allow the memory router to work inside a browser router
   */
  const FORCE_OVERRIDE_LOCATION_TO_ALLOW_MEMORY_ROUTER = null as unknown as ComponentProps<
    typeof LocationContext.Provider
  >['value']

  /**
   * The same must also be done for the route context when rendering within an Outlet
   */
  const FORCE_OVERRIDE_ROUTE_CONTEXT_TO_ALLOW_MEMORY_ROUTER = { outlet: null, matches: [], isDataRoute: false }

  return (
    <LocationContext.Provider value={FORCE_OVERRIDE_LOCATION_TO_ALLOW_MEMORY_ROUTER}>
      <RouteContext.Provider value={FORCE_OVERRIDE_ROUTE_CONTEXT_TO_ALLOW_MEMORY_ROUTER}>
        <RouterProvider
          router={router}
          fallbackElement={
            HIDE_LOADER_PATHS.includes(router.state.location.pathname) ? null : (
              <Stack space={'l'} justifyItems="center">
                <LoadingIcon />
              </Stack>
            )
          }
        />
      </RouteContext.Provider>
    </LocationContext.Provider>
  )
}
